import React, { FC } from 'react'
import { PageTitle } from '@/_metronic/layout/core'
import { TableWrapper } from '@/components/table/TableWrapper'
import { ButtonProps, ModalWrapperProps } from '@/components/table/core/_types'
import { Modal } from '@/components/table/modal/Modal'
import { getProducts } from '../core/_requests'
import { Product } from '../core/_models'
import { Columns } from './columns/_columns'
import { FilterForm, initialFilters } from './components/FilterForm'
import { CopyForm } from './components/CopyForm'
import ComputeStockform from './components/ComputeStockForm'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'

const Breadcrumbs = BreadcrumbsBuilder([{
  title: 'Home',
  path: '/'
}, {
  title: 'Passtocard',
  path: '/p2c/dashboard',
}])

/**
 * Toolbar buttons
 */
const buttons: Array<ButtonProps> = [{
  label: 'Compute stock',
  className: 'btn btn-info me-3',
  icon: {
    name: 'finance-calculator',
    className: 'fs-2'
  },
  openModal: 'compute-stock'
}]

/**
 * Modal wrapper to manage open modal
 */
const ProductModalWrapper: FC<ModalWrapperProps> = ({ itemForUpdate, action }) => {
  return (
    <>
      {itemForUpdate && action === 'copy' && (
        <Modal
          title={`Create copy of ${(itemForUpdate as Product).name}`}
        >
          <CopyForm />
        </Modal>
      )}

      {!itemForUpdate && action === 'compute-stock' && (
        <Modal
          title="Compute stock"
        >
          <ComputeStockform />
        </Modal>
      )}

    </>
  )
}

const ListWrapper = () => (
  <>
    <PageTitle breadcrumbs={Breadcrumbs}>Products list</PageTitle>
    <TableWrapper
      dataProvider={getProducts}
      cols={Columns}
      queryId="PRODUCTS_LIST"
      lookup={{ placeholder: 'Search Product' }}
      buttons={buttons}
      filters={{
        formFields: FilterForm,
        initialValues: initialFilters
      }}
      modals={ProductModalWrapper}
    />
  </>
)

export default ListWrapper
